import { useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import generatorThunk from "../../../redux/thunks";
import generatorActions from "../../../redux/actions";
import rectangle from "../../../assets/rectangle.png";

const GeneratorImageGrid = ({ imageAmount }) => {
  const dispatch = useDispatch();
  const generatedImages = useSelector((state) => state.generator.images);

  useEffect(() => {
    dispatch(generatorThunk.getGeneratedImages(imageAmount, "concept"));
  }, [imageAmount]);

  const handleImageClick = (image) => {
    dispatch(generatorActions.selectGeneratedImage(image));
  };

  return (
    <div className="generated-image-grid">
      {generatedImages
        ? generatedImages?.map((image, i) => {
            return (
              <div
                key={i}
                onClick={() => {
                  handleImageClick(image);
                }}
              >
                <img
                  alt="ai generated"
                  className="generated-grid-image"
                  src={image.image_uri}
                ></img>
              </div>
            );
          })
        : [...Array(imageAmount)].map((e, i) => (
            <img
              key={i}
              className="generated-grid-image"
              alt="rectangle"
              src={rectangle}
            ></img>
          ))}
      {/* 8x8 responsive image grid */}
      <style jsx>{`
        .generated-image-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-template-rows: repeat(5, 1fr);
          grid-gap: 1rem;
          padding-right: 1rem;
        }
        .generated-grid-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}</style>
    </div>
  );
};

export default GeneratorImageGrid;
